import React, { CSSProperties } from "react";
import { DoseDatatype, DoseMapMessage, MinMaxPair, TiledDoseMapImage } from "../BD21DataStream";
import fs from "fs"
import npyjs from "npyjs";
import jszip from "jszip";
//import html2canvas from 'html2canvas';
import { DoseAnalysisType, DoseMapUtility } from "../utils/DoseMapUtility";
//import { GenerateMap } from "./MapDocumentGenerator"

import './DoseMapDisplay.css'
import colorbar_logo from './img/colorbar_nolabel_only.png';
import download_file_logo from './img/326639_download_file_icon_white.png';
import upload_file_logo from './img/326640_upload_icon_white.png';
import pin_generic_logo from '@radnuc/react-ui-components/dist/img/pin-generic-white-32.png'
//import camera_logo from './img/photo_camera_48dp_white.png'

export enum DoseMapTypesEnum {DOSEMAP=1,DOSEMAX=2,UNCERTAINTY=3};
export enum DoseMapMinMaxEnum {MIN=1,MAX=2};

export interface BusyStatus {
    flag:boolean,
    percent:number,
}
export interface ScaleOverride {
    min: boolean,
    minVal?: number,
    max: boolean,
    maxVal?: number,
}
export const DoseMapLoadFromFileString = "LOAD FROM FILE";
export const DoseMapLoadedFromFileString = " [FILE]"
export const DoseMapLiveString = "LIVE";

export interface DoseMapAnalysisDisplayProps {
    doseMaps?: {[key:string]:DoseMapMessage | undefined},
    doseMapAnalysisInterface?: DoseMapAnalysisInterface
}

export interface DoseMapAnalysisDisplayState {
    controlOpen: boolean,
}

export interface DoseMapStats {
    lastUpdatedTime: number|null,
    dataScaleVal:{[doseDataType:number]:MinMaxPair}
}

export interface DoseMapAnalysisInterface {
    doseMapControlOpen: boolean,
    doseMapSelected: string | undefined,
    doseMapsAvailable: string[] | undefined,
    doseMapsAvailableStats?: {[key:string]:DoseMapStats},
    doseMapType?: DoseMapTypesEnum | undefined,
    doseMapDateSelected: {[key:string]:string},
    doseMapDateAvailable: string[] | undefined,
    doseMapLive?: boolean,
    doseMapAnalysisType?: DoseAnalysisType,
    doseMapHideAlertPins?: boolean,
    doseMapBusy?: {[key:string]:BusyStatus},
    doseMapScaleOverride?: {[key:string]:{[key:string]:ScaleOverride}},
    selectDoseMap: (key: string | undefined) => void,
    selectDoseMapType: (key: DoseMapTypesEnum | undefined) => void,
    selectDoseMapDate: (key: string, date:string) => void,
    load: (key: string, message: DoseMapMessage) => void,
    selectLiveData?: (flag:boolean) => void,
    selectDoseMapAnalysisType: (type:DoseAnalysisType|undefined) => void,
    setDoseMapBusy?: (key:string, flag:boolean, percent?:number) => void,
    setScale?: (key: string, type: DoseMapTypesEnum, minMax:DoseMapMinMaxEnum, value:number|null) => void,
    setOverride?: (key: string, type: DoseMapTypesEnum, minMax:DoseMapMinMaxEnum, flag:boolean) => void,
    setDoseMapHideAlertPins?: (flag?:boolean) => void,
    setControlDisplayOpen: (flag?:boolean) => void,
}

type manifestJSON = {
    time_updated: any; id: string; center: { lat: number; lon: number; }; delta_lat: number; delta_lon: number;
}

export class DoseMapAnalysisDisplay extends React.Component<DoseMapAnalysisDisplayProps,DoseMapAnalysisDisplayState > {

    constructor(props: DoseMapAnalysisDisplayProps) {
        super(props)

        this.state={
            controlOpen:true
        }

        //this.loadFileButtonClick = this.loadFileButtonClick.bind(this);
        this.saveFileButtonClick = this.saveFileButtonClick.bind(this);
        this.handleDoseMapButtonClick = this.handleDoseMapButtonClick.bind(this);
        this.handleMaxDoseMapButtonClick = this.handleMaxDoseMapButtonClick.bind(this);
        this.handleUncertaintyMapButtonClick = this.handleUncertaintyMapButtonClick.bind(this);
        this.handleDoseMapHideAlertPinsClick = this.handleDoseMapHideAlertPinsClick.bind(this);
        this.handleScreenCaptureClick = this.handleScreenCaptureClick.bind(this);
    }
    /*
    loadFileButtonClick(){
        let button = document.getElementById('inputFieldId');
        if(button !== null){
            button.click();
            console.log('click loadfile')
        }
    }
    */
    saveFileButtonClick(){
        console.log('click savefile')
        let thisDoseMap:DoseMapMessage|undefined;
        if(this.props.doseMapAnalysisInterface?.doseMapSelected !== undefined && this.props.doseMaps){
            //thisDoseMap = this.props.doseMaps[this.props.doseMapAnalysisInterface?.doseMapSelected];
            thisDoseMap = this.props.doseMaps['A'];
            console.log('**Save download only saves FORGROUND**')
        }
        if(thisDoseMap!== undefined){
            console.log(thisDoseMap)
            if(thisDoseMap.regions !== undefined && thisDoseMap.regions !== null && thisDoseMap.regions.length > 0){

                let outZip = new jszip();
                for(let i=0;i<thisDoseMap.regions.length;i++){
                    const thisRegion = thisDoseMap.regions[i];
                    const thisFilename = thisRegion.uuid+".npz";
                    const thisBlob = thisRegion.npzBlob;
                    if(thisBlob){
                        console.log("adding "+thisFilename)
                        outZip.file(thisFilename, thisBlob);
                    }
                }
                //Add manifest
                if(thisDoseMap.manifest){
                    let manifestBlob = new Blob([thisDoseMap.manifest], { type: "application/json" });
                    outZip.file("manifest.json", manifestBlob);
                }

                //Save zip file
                const d = new Date();
                const datestring = d.toLocaleString("en-us", {month: "short"})+'_'+d.getDate()+'_'+d.getFullYear();
                const timestring = d.toLocaleString('en-US', {hour:'numeric',minute:'numeric',second:'numeric',hour12: true }).replace(/:/g,"_").replace(" ","_");
                const download_filename = "DoseMapSavedOn_"+datestring+"_"+timestring+".zip";

                //const download_filename = "testdownload.zip"
                outZip.generateAsync({type:"blob"}).then(function(content){

                    console.log('saving zipped file')
                    let element = document.createElement('a');
                    const url = URL.createObjectURL(content);
                    element.setAttribute('href', url);
                    element.setAttribute('download', download_filename);

                    element.style.display = 'none';
                    document.body.appendChild(element);

                    element.click();

                    document.body.removeChild(element);
                })
            }
        }

    }
    handleDoseMapButtonClick(){
        console.log('click handleDoseMapButtonClick')
        if(this.props.doseMapAnalysisInterface?.doseMapType===undefined || this.props.doseMapAnalysisInterface?.doseMapType!==DoseMapTypesEnum.DOSEMAP){
            this.props.doseMapAnalysisInterface?.selectDoseMapType(DoseMapTypesEnum.DOSEMAP);
        } else {
            this.props.doseMapAnalysisInterface?.selectDoseMapType(undefined);
        }
    }

    handleMaxDoseMapButtonClick(){
        //console.log('click handleMaxDoseMapButtonClick')
        if(this.props.doseMapAnalysisInterface?.doseMapType===undefined || this.props.doseMapAnalysisInterface?.doseMapType!==DoseMapTypesEnum.DOSEMAX){
            this.props.doseMapAnalysisInterface?.selectDoseMapType(DoseMapTypesEnum.DOSEMAX)
        } else {
            this.props.doseMapAnalysisInterface?.selectDoseMapType(undefined);
        }

    }

    handleUncertaintyMapButtonClick(){
        //console.log('click handleUncertaintyMapButtonClick')
        if(this.props.doseMapAnalysisInterface?.doseMapType===undefined || this.props.doseMapAnalysisInterface?.doseMapType!==DoseMapTypesEnum.UNCERTAINTY){
            this.props.doseMapAnalysisInterface?.selectDoseMapType(DoseMapTypesEnum.UNCERTAINTY)
        } else {
            this.props.doseMapAnalysisInterface?.selectDoseMapType(undefined);
        }
    }

    handleDoseMapHideAlertPinsClick(){
        //console.log('click handleDoseMapHideAlertPinsClick')
        if(this.props.doseMapAnalysisInterface?.setDoseMapHideAlertPins){
            this.props.doseMapAnalysisInterface?.setDoseMapHideAlertPins();
        }
    }

    handleScreenCaptureClick(){
        console.log('click handleScreenCaptureClick');
        /*
        html2canvas(document.body).then(function(canvas) {
            //document.body.appendChild(canvas);
              var link = document.createElement('a');
              link.download = 'screencapture.png';
              link.href = canvas.toDataURL()
              link.click();
        });
        */
    }

    render(){

        let controlNavClassName = "controlnav";
        if (this.props.doseMapAnalysisInterface?.doseMapControlOpen) {
            controlNavClassName += " open"
        }


        let thisDoseMap:DoseMapMessage|undefined;
        if(this.props.doseMapAnalysisInterface?.doseMapSelected !== undefined && this.props.doseMaps){
            thisDoseMap = this.props.doseMaps[this.props.doseMapAnalysisInterface?.doseMapSelected];
        }
        let doseMapButtonClass = "unavailable";// unclickable";
        let maxDoseMapButtonClass = "unavailable";// unclickable";
        let uncertMapButtonClass = "unavailable";// unclickable";
        //this.dose_map_available = false;
        //this.uncertainty_map_available = false;
        if(thisDoseMap !== undefined){
            if(thisDoseMap.regions !== undefined && thisDoseMap.regions !== null && thisDoseMap.regions.length > 0){

                let used_uuids: string[] = [];

                thisDoseMap.regions.forEach(region => {
                    if(region.doseMap !== null){
                        doseMapButtonClass = "available";
                        //this.dose_map_available = true;
                    }
                    if(region.maxDoseMap !== null){
                        maxDoseMapButtonClass = "available";
                        //this.dose_max_available = true;
                    }
                    if(region.uncertMap !== null){
                        uncertMapButtonClass = "available";
                        //this.uncertainty_map_available = true;
                    }
                });
            }
        }
        if(this.props.doseMapAnalysisInterface?.doseMapType){
            if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAP){// && doseMapButtonClass==="available"){
                doseMapButtonClass += " selected";
            } else if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.DOSEMAX){// && maxDoseMapButtonClass === "available"){
                maxDoseMapButtonClass += " selected";
            } else if(this.props.doseMapAnalysisInterface?.doseMapType === DoseMapTypesEnum.UNCERTAINTY){// && uncertMapButtonClass === "available"){
                uncertMapButtonClass += " selected";
            }
        }

        let doseRateMapButton =
            <div className={"round-button "+doseMapButtonClass}
                style={{margin: '5px', padding: '5px', width:'70px',fontSize:'0.8em'}} onClick={this.handleDoseMapButtonClick}>
                <div>DOSE RATE MAP</div>
            </div>
        let maxDoseRateMapButton =
            <div className={"round-button "+maxDoseMapButtonClass}
                style={{margin: '5px', padding: '5px', width:'70px',fontSize:'0.8em'}} onClick={this.handleMaxDoseMapButtonClick}>
                <div>MAX DOSE RATE MAP</div>
            </div>
        let uncertaintyMapButton =
            <div className={"round-button "+uncertMapButtonClass}
                style={{margin: '5px', padding: '5px', width:'70px',fontSize:'0.8em'}} onClick={this.handleUncertaintyMapButtonClick}>
                <div>UNCERT. MAP</div>
            </div>

        let saveButtonAClass = "disabled";
        if(!this.props.doseMapAnalysisInterface?.doseMapDateSelected['A'].includes(DoseMapLoadFromFileString) &&
            this.props.doseMapAnalysisInterface?.doseMapDateSelected['A']!=='' &&
            this.props.doseMaps && this.props.doseMaps!['A'] &&
            this.props.doseMapAnalysisInterface?.doseMapBusy && this.props.doseMapAnalysisInterface?.doseMapBusy['A'].flag !== true){

            saveButtonAClass = "";
        }
        const saveButton =
                <div className={"round-button "+saveButtonAClass}
                    style={{margin: '5px', padding: '5px', width:'22px'}} onClick={this.saveFileButtonClick} title={"Save Data To Local File"}>
                    <div className="inv-type-indicator-img" style={{marginRight:'0px',padding:'0px'}}>
                        <img style={{background:'rbg(40,40,40)'}} className="dosemap-type-img" src={download_file_logo}/>
                    </div>
                </div>

        const undisplay_char = '\u2298';
        let hide_symbol;
        if(this.props.doseMapAnalysisInterface?.doseMapHideAlertPins){
            hide_symbol =
            <div style={{ position: 'relative', right: '29px', bottom: '30px', padding: '0px',margin:'0px',height:'0px',width:'0px',color:'red',fontSize:'3em',zIndex:9999 }}>
                {undisplay_char}
            </div>
        }
        const toggleAlertPinsButton =
            <div className={"round-button "}
                style={{margin: '5px', padding: '5px', width:'20px',fontSize:'0.8em',backgroundColor:'unset'}} onClick={this.handleDoseMapHideAlertPinsClick}>
                <img src={pin_generic_logo} alt="Marker"/> <div style={{ width: '5px' }}> </div>
                {hide_symbol}
            </div>
        /*
        const screenCaptureButton =
            <div className={"round-button "}
                style={{width:'20px',fontSize:'0.8em',backgroundColor:'unset'}} onClick={this.handleScreenCaptureClick}>
                <img src={camera_logo} style={{ width: '40px' }} alt="Marker"/> <div style={{ width: '5px' }}> </div>
            </div>
        */

        let toggleAlertPinsRemoteButton;
        if(!this.props.doseMapAnalysisInterface?.doseMapControlOpen && this.props.doseMapAnalysisInterface?.doseMapType){
            toggleAlertPinsRemoteButton =
                <div className={"round-button"} style={{margin:'10px',height:'40px'}}>
                    {toggleAlertPinsButton}
                </div>
        }


        let doseMapA;
        let doseMapB;
        let doseMapC;
        if(this.props.doseMaps){
            doseMapA = this.props.doseMaps['A'];
            doseMapB = this.props.doseMaps['B'];
            doseMapC = this.props.doseMaps['C'];
        }




        return(
            <div style={{ display: 'flex', flex: '1', flexDirection: 'column'}}>
                <div style={{ display: 'flex', position: 'absolute', right: '5px', top: '-70px', flexDirection:'row' }}>
                    {toggleAlertPinsRemoteButton}
                    <DoseColorbarDisplay doseMap={thisDoseMap} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface} />
                </div>
                <div id="dosemap-control-nav" className={controlNavClassName} style={{overflow:'hidden'}}>
                    <div className="Plot" style={{ display: 'flex', flex: '1', flexDirection: 'column', alignSelf:'flex-end', backgroundColor:'#282828', margin:'5px',padding:'10px',
                        borderRadius: '0px', borderBottomLeftRadius:'5px', borderBottomRightRadius:'0px', height:'fit-content', width:'fit-content'}}>

                        <div style={{ display: 'flex', flexDirection:'row', justifyItems:'center',alignItems:'center' }}>
                            <div style={{ display: 'flex', color: 'lightgray',paddingRight:'5px'}}>Display</div>
                            {doseRateMapButton}
                            {maxDoseRateMapButton}
                            {uncertaintyMapButton}
                            {toggleAlertPinsButton}
                        </div>
                        <div style={{ display: 'flex', flexDirection:'column', alignItems:'flex-start' }}>
                            <div className='dose-control-row' style={{ display: 'flex', flexDirection:'column', alignItems:'flex-start' }}>
                                <div style={{ display: 'flex', flexDirection:'row', justifyItems:'center',alignItems:'center' }}>
                                    <DoseMapSelectControlDisplay key={'A'} doseMapKey={'A'} doseMapName={'FOREGRND'} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface} showLoadButton={true}/>
                                    {saveButton}
                                </div>
                                <DoseMapStatDisplay doseMapKey={'A'} doseMap={doseMapA} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface}/>
                            </div>
                            <div className='dose-control-row' style={{ display: 'flex', flex: '1', flexDirection:'column', alignItems:'flex-start',width:'100%' }}>
                                <DoseMapSelectControlDisplay key={'B'} doseMapKey={'B'} doseMapName={'BASELNE'} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface} showLoadButton={true}/>
                                <DoseMapStatDisplay doseMapKey={'B'} doseMap={doseMapB} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface}/>
                            </div>

                            <div className='dose-control-row' style={{ display: 'flex', flexDirection:'column', alignItems:'flex-start',width:'100%' }}>
                                <DoseMapSelectControlDisplay key={'C'} doseMapKey={'C'} doseMapName={'RESULT'} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface} showLoadButton={false}/>
                                <DoseMapStatDisplay doseMapKey={'C'} doseMap={doseMapC} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface}/>
                            </div>

                        </div>
                        {/*
                        <div style={{ display: 'flex', flexDirection:'row', justifyContent:'flex-end',marginRight:'5px'}}>
                        {screenCaptureButton}
                        </div>
                        */}
                    </div>
                </div>
            </div>
        )
    }
}

/*******************************************************************************/

export interface DoseMapSelectControlDisplayProps {
    doseMapName: string,
    doseMapKey: string,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
    showLoadButton?: boolean,
}

export interface DoseMapSelectControlDisplayState {
}

export class DoseMapSelectControlDisplay extends React.Component<DoseMapSelectControlDisplayProps> {

    constructor(props: DoseMapSelectControlDisplayProps) {
        super(props)

        this.handleDoseMapSelectClick = this.handleDoseMapSelectClick.bind(this);
        //this.saveFileButtonClick = this.saveFileButtonClick.bind(this);
        this.loadFileButtonClick = this.loadFileButtonClick.bind(this);
        this.loadMapDoseZippedData = this.loadMapDoseZippedData.bind(this);
        this.setDoseMapBusy = this.setDoseMapBusy.bind(this);

    }

    setDoseMapBusy(key:string, flag:boolean, percent?:number){
        if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
            this.props.doseMapAnalysisInterface.setDoseMapBusy(key,flag,percent);
        }
    }

    loadFileButtonClick(){
        let button = document.getElementById('inputFieldId'+this.props.doseMapKey);
        if(button !== null){
            button.click();
            console.log('click loadfile')
        }
    }

    handleDoseMapSelectClick(){
        console.log('click handleDoseMapSelectClick')
        if(this.props.doseMapAnalysisInterface?.doseMapSelected===undefined || this.props.doseMapAnalysisInterface?.doseMapSelected!==this.props.doseMapName){
            this.props.doseMapAnalysisInterface?.selectDoseMap(this.props.doseMapKey);
        } else {
            this.props.doseMapAnalysisInterface?.selectDoseMapType(undefined);
        }
    }

    async loadZippedData(fileContents:ArrayBuffer){
        const zip = await jszip.loadAsync(fileContents);
        console.log(fileContents);
        return zip
    }

    loadMapDoseZippedData(file:File, doseMapKey:string, callback:(key:string,doseMapMessage:DoseMapMessage)=>void){
        const reader = new FileReader();
        this.setDoseMapBusy(doseMapKey,true,0);
        reader.onload = (e) => {
            // Do something with the file contents
            if(e.target !== null){
                const fileContents = e.target.result as ArrayBuffer;
                //Read zip
                this.loadZippedData(fileContents).then((zipContent:jszip)=>{
                    console.log('zip loaded')
                    //Get manifest first
                    const manifestfile = zipContent.files["manifest.json"];
                    if(manifestfile){
                        manifestfile.async('string').then(async (manifeststring)=>{
                            let manifest = JSON.parse(manifeststring);
                            if(manifest !== undefined){
                                let dose_map_message:DoseMapMessage = { regions: [],
                                                                        time: null,
                                                                        lastUpdatedTime: null,
                                                                        manifest: manifeststring,
                                                                        displayScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                                        globalScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                                        dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}}}

                                if (manifest.regions !== undefined && Array.isArray(manifest.regions)){

                                    const regions_total =  manifest.regions.length;
                                    let regions_index = 0;

                                    let lastUpdatedTime = 0;
                                    //Load all regions in manifest
                                    for(const region of manifest.regions){

                                        if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
                                            const percent = Math.floor((regions_index/regions_total)*100);
                                            //console.log('Progress '+percent)
                                            this.props.doseMapAnalysisInterface?.setDoseMapBusy(doseMapKey,true,percent);
                                        }


                                        const timeUpdated = region.time_updated;
                                        //Zip
                                        const thisZipFile = zipContent.files[region.id+'.npz']
                                        await DoseMapUtility.loadNPZ(thisZipFile).then((result)=>{
                                            //console.log("making dosemap message")
                                            //TODO FIX HACK HERE
                                            const doseMaxRaw = result.npzData['dose_max'];
                                            const doseMapRaw = result.npzData['dose_map'];
                                            const doseMapStdRaw = result.npzData['dose_map_std'];
                                            const doseMaxStdRaw = result.npzData['dose_max_std'];
                                            const maskMapRaw = result.npzData['mask_map'];
                                            const maskMaxRaw = result.npzData['mask_max'];

                                            //console.log('add tile: '+region.id);
                                            let thisRegion:TiledDoseMapImage = {uuid: region.id,
                                                                              time: timeUpdated,
                                                                              doseMap: null, //N.B. Updated later
                                                                              maxDoseMap: null, //N.B. Updated later
                                                                              uncertMap: null, //N.B. Updated later
                                                                              doseRaw: doseMapRaw,
                                                                              doseStdRaw: doseMapStdRaw,
                                                                              doseMaxRaw:doseMaxRaw,
                                                                              doseMaxStdRaw: doseMaxStdRaw,
                                                                              maskMap: maskMapRaw,
                                                                              maskMax: maskMaxRaw,
                                                                              npzBlob: result.blob,
                                                                              dataScaleVal: {[DoseDatatype.DOSE_RATE]:{min:null,max:null},[DoseDatatype.MAX_DOSE_RATE]:{min:null,max:null},[DoseDatatype.UNCERTAINTY]:{min:null,max:null}},
                                                                              swCorner: {lat:region.center.lat-(region.delta_lat/2.0),
                                                                                         lon:region.center.lon-(region.delta_lon/2.0)},
                                                                              neCorner: {lat:region.center.lat+(region.delta_lat/2.0),
                                                                                         lon:region.center.lon+(region.delta_lon/2.0)}}


                                             DoseMapUtility.updateDataStatisticsForRegion(thisRegion);

                                             dose_map_message.regions!.push(thisRegion);
                                             if(dose_map_message.lastUpdatedTime === null || (thisRegion.time !== null && dose_map_message.lastUpdatedTime < thisRegion.time)){
                                                 dose_map_message.lastUpdatedTime = thisRegion.time;
                                             }
                                             //console.log('pushed '+region.id);
                                         })
                                         if(timeUpdated > lastUpdatedTime){
                                             lastUpdatedTime = timeUpdated;
                                         }
                                         regions_index++;
                                     } //for all regions
                                     dose_map_message.lastUpdatedTime = lastUpdatedTime;

                                     console.log('Total Regions: '+regions_total)
                                     this.setDoseMapBusy('MAP',true);
                                     setTimeout(()=>{
                                         dose_map_message = DoseMapUtility.updateDataStatistics(dose_map_message);
                                         //DoseMapUtility.resetDisplayStatisticsToData(dose_map_message);
                                         //dose_map_message = DoseMapUtility.updateDoseMaps(dose_map_message);
                                         this.setDoseMapBusy('MAP',false);
                                         this.setDoseMapBusy(doseMapKey,false);

                                         const this_path = file.name;
                                         const str = this_path.split('/');
                                         const this_file = str[str.length-1]

                                         this.props.doseMapAnalysisInterface?.selectDoseMapDate(doseMapKey,this_file+DoseMapLoadedFromFileString);
                                         //console.log('returning dose map message ');
                                         callback(doseMapKey,dose_map_message);
                                     },10);


                                 } else {
                                     //manifest region empty
                                     console.log("REGION EMPTY IN DOWNLOAD FILE")
                                     if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
                                         this.props.doseMapAnalysisInterface?.setDoseMapBusy(doseMapKey,false,-1);
                                     }
                                 }

                             } else {
                                 console.log("REGION UNDEFINED IN DOWNLOAD FILE")
                                 if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
                                     this.props.doseMapAnalysisInterface?.setDoseMapBusy(doseMapKey,false,-1);
                                 }
                             }
                        }).catch((err)=>{
                            console.log('Manifest file parse error');
                                this.setDoseMapBusy(doseMapKey,false,-1);
                            }   ); //parsing manifest
                    } else {
                        console.log("MANIFEST MISSING FROM DOSE MAP DOWNLOAD FILE")
                        if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
                            this.props.doseMapAnalysisInterface?.setDoseMapBusy(doseMapKey,false,-1);
                        }
                    }
                }).catch((err)=>{
                    console.log('UNZIP ERROR');
                        this.setDoseMapBusy(doseMapKey,false,-1);
                    }
                );

            }
        };

        // Read the file
        reader.readAsArrayBuffer(file);
    }

    render(){
        let doseMapClass = 'unavailable';
        this.props.doseMapAnalysisInterface?.doseMapsAvailable?.forEach(element => {
            if(element === this.props.doseMapKey){
                doseMapClass = 'available';
            }
        });
        if(this.props.doseMapAnalysisInterface?.doseMapSelected === this.props.doseMapKey){
            doseMapClass += ' selected'//+doseMapClass
        }

        let handleInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
            console.log(event.target.value);
            if(event.target.files !== null){
                let file = event.target.files[0];

                if (file) {
                    if(this.props.doseMapAnalysisInterface !== undefined){
                        this.loadMapDoseZippedData(file,this.props.doseMapKey,this.props.doseMapAnalysisInterface.load);
                    }
                }
                //reset target value. This allows you to use the load function more than once
                event.target.value = '';
            } else {
                //Nothing selected
                this.props.doseMapAnalysisInterface?.selectDoseMapDate(this.props.doseMapKey,'--');
            }
        };
        let loadButtonClass = "disabled";
        if(this.props.doseMapAnalysisInterface?.doseMapDateSelected[this.props.doseMapKey].includes(DoseMapLoadFromFileString)){
            loadButtonClass = "";
        }
        let loadButton;
        if(this.props.showLoadButton){
            loadButton =    <div id={'load-from-file-button-'+this.props.doseMapKey} className={"round-button "+loadButtonClass}
                                style={{margin: '5px', padding: '5px', width:'22px'}} onClick={this.loadFileButtonClick} title={"Upload From Local File"}>
                                <div className="inv-type-indicator-img" style={{marginRight:'0px',padding:'0px'}}>
                                    <img style={{background:'rbg(40,40,40)'}} className="dosemap-type-img" src={upload_file_logo}/>
                                </div>
                                <input type="file" style={{display:"none"}} id={"inputFieldId"+this.props.doseMapKey} onChange={handleInputValue}/>
                            </div>
        }

        let dropdownDisplay;
        if(this.props.doseMapKey==='C'){
            dropdownDisplay = <AnalysisMethodSelectDisplay doseMapAnalysisInterface={this.props.doseMapAnalysisInterface}/>
        } else {
            dropdownDisplay =<DoseMapSelectDisplay doseMapKey={this.props.doseMapKey} doseMapAnalysisInterface={this.props.doseMapAnalysisInterface}/>
        }


        let doseMapBusyIndicator;
        //console.log(this.props.doseMapAnalysisInterface?.doseMapBusy);
        if(this.props.doseMapAnalysisInterface?.doseMapBusy){
            //console.log("doseMapBusy: "+this.props.doseMapAnalysisInterface?.doseMapBusy[this.props.doseMapKey]);
            if(this.props.doseMapAnalysisInterface?.doseMapBusy[this.props.doseMapKey].flag === true){
                let busyPercentString;
                if(this.props.doseMapAnalysisInterface?.doseMapBusy[this.props.doseMapKey].percent > -1){
                    busyPercentString = this.props.doseMapAnalysisInterface?.doseMapBusy[this.props.doseMapKey].percent.toFixed(0)+"%";
                }
                doseMapBusyIndicator =
                <div style={{ display: 'flex', position:'absolute'}}>
                    <div style={{ display: 'flex', position: 'relative', top: '39px', left: '35px', padding: '0px', zIndex:'9999',alignItems:'center',justifyContent:'center'}}>
                        <div id="dosemap-loader" className="percent-loader"></div>
                        <div style={{ display: 'flex', position: 'absolute', padding: '0px', zIndex:'9999', color:'lightgray', fontSize:'0.7em', justifyContent:'flex-end'}}>
                        {busyPercentString}
                        </div>
                    </div>
                </div>
            }
        }

        return(
            <div style={{ display: 'flex', flexDirection:'row', alignItems:'center' }}>
                {doseMapBusyIndicator}
                <div className={"round-button "+doseMapClass}
                    style={{margin: '5px', padding: '5px', width:'85px'}} onClick={this.handleDoseMapSelectClick}>
                    <div>{this.props.doseMapName}</div>
                </div>
                {dropdownDisplay}
                {loadButton}
            </div>
        )
    }
}

/*******************************************************************************/
export interface DoseColorbarDisplayProps {
    doseMap?: DoseMapMessage,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
}

export interface DoseColorbarDisplayState {
    displayMinInput?: boolean,
    displayMaxInput?: boolean
}

export class DoseColorbarDisplay extends React.Component<DoseColorbarDisplayProps,DoseColorbarDisplayState> {

    displayMinInput?: boolean;
    displayMaxInput?: boolean;

    constructor(props: DoseMapSelectControlDisplayProps) {
        super(props)

        this.state={
            displayMinInput: false,
            displayMaxInput: false,
        }

        this.handleSetMinValueClick = this.handleSetMinValueClick.bind(this);
        this.handleSetMaxValueClick = this.handleSetMaxValueClick.bind(this);
        this.setMinThresh = this.setMinThresh.bind(this);
        this.setMaxThresh = this.setMaxThresh.bind(this);
        this.makeThreshDisplay = this.makeThreshDisplay.bind(this);
    }
    componentDidUpdate(prevProps: DoseColorbarDisplayProps, prevState: DoseColorbarDisplayState) {
        if(this.state.displayMinInput !== prevState.displayMinInput){
            console.log('displayMinInput changed to '+ this.state.displayMinInput);
            this.displayMinInput = this.state.displayMinInput;
            this.render();
        }
    }

    handleSetMinValueClick(){
        console.log('Click set min value')
        this.displayMinInput = true;
        this.setState({
            displayMinInput:!this.state.displayMinInput,
        })
        if(this.state.displayMaxInput){
            this.setState({
                displayMaxInput:false,
            })
        }
    }
    handleSetMaxValueClick(){
        console.log('Click set max value')
        this.setState({
            displayMaxInput:!this.state.displayMaxInput,
        })
        if(this.state.displayMinInput){
            this.setState({
                displayMinInput:false,
            })
        }
    }

    setDoseMapBusy(key:string, flag:boolean, percent?: number){
        if(this.props.doseMapAnalysisInterface?.setDoseMapBusy){
            this.props.doseMapAnalysisInterface.setDoseMapBusy(key,flag,percent);
        }
    }

    setMinThresh(min:number|null, doseMapType:DoseMapTypesEnum, applyToAllFlag:boolean|null){
        console.log('setMinThresh to: ' +min)
        if(this.props.doseMapAnalysisInterface?.setScale && this.props.doseMapAnalysisInterface?.setOverride){
            if(applyToAllFlag === null){
                //CHANGE FOR C
                this.setState({
                    displayMinInput:false,
                })
                this.props.doseMapAnalysisInterface?.setScale("C", doseMapType, DoseMapMinMaxEnum.MIN,min);

            } else if (applyToAllFlag){
                this.setState({
                    displayMinInput:false,
                })
                this.props.doseMapAnalysisInterface?.setOverride("GANG",doseMapType,DoseMapMinMaxEnum.MIN,true);
                this.props.doseMapAnalysisInterface?.setOverride("A",doseMapType,DoseMapMinMaxEnum.MIN,true);
                this.props.doseMapAnalysisInterface?.setOverride("B",doseMapType,DoseMapMinMaxEnum.MIN,true);
                this.props.doseMapAnalysisInterface?.setScale("A", doseMapType, DoseMapMinMaxEnum.MIN,min);
                this.props.doseMapAnalysisInterface?.setScale("B", doseMapType, DoseMapMinMaxEnum.MIN,min);

            } else {
                const key = this.props.doseMapAnalysisInterface?.doseMapSelected;
                if(key){
                    this.setState({
                        displayMinInput:false,
                    })
                    this.props.doseMapAnalysisInterface?.setOverride("GANG",doseMapType,DoseMapMinMaxEnum.MIN,false);
                    this.props.doseMapAnalysisInterface?.setOverride(key,doseMapType,DoseMapMinMaxEnum.MIN,true);
                    this.props.doseMapAnalysisInterface?.setScale(key, doseMapType, DoseMapMinMaxEnum.MIN,min);
                }
            }

        }
    }
    setMaxThresh(max:number|null, doseMapType:DoseMapTypesEnum, applyToAllFlag:boolean|null){
        console.log(max)
        if(this.props.doseMapAnalysisInterface?.setScale && this.props.doseMapAnalysisInterface?.setOverride){
            if(applyToAllFlag === null){
                //CHANGE FOR C
                this.setState({
                    displayMinInput:false,
                })
                this.props.doseMapAnalysisInterface?.setScale("C", doseMapType, DoseMapMinMaxEnum.MAX,max);

            } else if (applyToAllFlag){
                this.setState({
                    displayMaxInput:false,
                })
                this.props.doseMapAnalysisInterface?.setOverride("GANG",doseMapType,DoseMapMinMaxEnum.MAX,true);
                this.props.doseMapAnalysisInterface?.setScale("A", doseMapType, DoseMapMinMaxEnum.MAX,max);
                this.props.doseMapAnalysisInterface?.setScale("B", doseMapType, DoseMapMinMaxEnum.MAX,max);

            } else {
                const key = this.props.doseMapAnalysisInterface?.doseMapSelected;
                if(key){
                    this.setState({
                        displayMaxInput:false,
                    })
                    this.props.doseMapAnalysisInterface?.setOverride("GANG",doseMapType,DoseMapMinMaxEnum.MAX,false);
                    this.props.doseMapAnalysisInterface?.setScale(key, doseMapType, DoseMapMinMaxEnum.MAX,max);
                }
            }
        }
    }

    makeThreshDisplay(label:string, doseMapType:DoseMapTypesEnum, doseMapMaxMin:DoseMapMinMaxEnum, initValue:number, resetValue:number, delta:number, onclick:(event: React.MouseEvent<HTMLElement>)=>void, style:CSSProperties | undefined){
        //click to change min threshold
        let threshDisplay;
        let displayTrigger;
        if(doseMapMaxMin === DoseMapMinMaxEnum.MIN){
            displayTrigger = this.state.displayMinInput;
        } else {
            displayTrigger = this.state.displayMaxInput;
        }

        if(displayTrigger){
            threshDisplay = <SettingsInputDisplay label={label} doseMapMaxMin={doseMapMaxMin} initValue={initValue} resetValue={resetValue}
                callback={
                    (returnvalue,applyToAllFlag) => {
                        if(doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                            this.setState({displayMinInput:false});
                        } else {
                            this.setState({displayMaxInput:false});
                        }
                        this.setDoseMapBusy('MAP',true,-1);
                        setTimeout(()=>{
                            if(doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                                this.setMinThresh(returnvalue,doseMapType,applyToAllFlag);
                                //this.setMinThresh(returnvalue,doseMapType,applyToAllFlag)
                            } else {
                                this.setMaxThresh(returnvalue,doseMapType,applyToAllFlag);
                                //this.setMaxThresh(returnvalue,doseMapType,applyToAllFlag)
                            }
                            this.setDoseMapBusy('MAP',false,-1);
                        },10) //Slight delay

                    }
                } doseMapAnalysisInterface={this.props.doseMapAnalysisInterface} style={style}/>
        }
        let signif_digit = 1;
        if(delta < 0.08)
            signif_digit = 2;


        let resetIndicator='\u25bd';
        //if(this.props.initValue !== this.props.resetValue ){
        if(this.props.doseMapAnalysisInterface){
            const thisDoseMapTypeSelected = this.props.doseMapAnalysisInterface?.doseMapType;
            const thisOverride = this.props.doseMapAnalysisInterface?.doseMapScaleOverride;
            const thisDoseMapSelected = this.props.doseMapAnalysisInterface?.doseMapSelected;
            if(thisOverride && thisDoseMapSelected && thisDoseMapTypeSelected){
                if(doseMapMaxMin === DoseMapMinMaxEnum.MAX){
                    if(thisOverride[thisDoseMapTypeSelected])
                        //if(thisOverride[thisDoseMapTypeSelected][thisDoseMapSelected].max || (thisOverride[thisDoseMapTypeSelected]['GANG'].max && thisDoseMapSelected !=='C')){
                        if(thisOverride[thisDoseMapTypeSelected][thisDoseMapSelected].max){
                            resetIndicator = '\u25bc';
                        }
                } else if(doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                    if(thisOverride[thisDoseMapTypeSelected])
                        //if(thisOverride[thisDoseMapTypeSelected][thisDoseMapSelected].min || (thisOverride[thisDoseMapTypeSelected]['GANG'].min && thisDoseMapSelected !=='C')){
                        if(thisOverride[thisDoseMapTypeSelected][thisDoseMapSelected].min){
                            resetIndicator = '\u25bc';
                        }
                }
            }
        }
        let thisLabel =
            <div key={'label'+label} style={{cursor:'pointer'}}>
                <div className={'colorbar-ticklabel-clickable'} onClick={onclick}>
                    <div>{initValue.toFixed(signif_digit)}</div>
                    <div>{resetIndicator}</div>
                </div>
                {threshDisplay}
            </div>
            return thisLabel;
    }



    render(){
        //console.log('DoseMapColormap render @ '+Date.now());
        let colorbarValueLabelDisplay:JSX.Element[] = [];
        let doseMapLabel = "";
        const thisDoseMapType = this.props.doseMapAnalysisInterface?.doseMapType;
        if(thisDoseMapType && this.props.doseMap){
            if(thisDoseMapType === DoseMapTypesEnum.DOSEMAP){
                if(this.props.doseMapAnalysisInterface?.doseMapAnalysisType===DoseAnalysisType.ZSCORE && this.props.doseMapAnalysisInterface?.doseMapSelected==='C'){
                    doseMapLabel = "Dose Map [Z-Score]"
                } else {
                    doseMapLabel = "Dose Map [uR/hr]"
                }
            } else if(thisDoseMapType === DoseMapTypesEnum.DOSEMAX){
                if(this.props.doseMapAnalysisInterface?.doseMapAnalysisType===DoseAnalysisType.ZSCORE && this.props.doseMapAnalysisInterface?.doseMapSelected==='C'){
                    doseMapLabel = "Max Dose Map [Z-Score]"
                } else {
                    doseMapLabel = "Max Dose Map [uR/hr]"
                }
            } else if(thisDoseMapType === DoseMapTypesEnum.UNCERTAINTY){
                if(this.props.doseMapAnalysisInterface?.doseMapAnalysisType===DoseAnalysisType.ZSCORE && this.props.doseMapAnalysisInterface?.doseMapSelected==='C'){
                    doseMapLabel = "Uncertainty Map [Z-Score]"
                } else {
                    doseMapLabel = "Uncertainty Map [uR/hr]"
                }
            }

            if(this.props.doseMap.displayScaleVal[thisDoseMapType].max !==null && this.props.doseMap.displayScaleVal[thisDoseMapType].min !==null &&
                this.props.doseMap.dataScaleVal[thisDoseMapType].max!==null && this.props.doseMap.dataScaleVal[thisDoseMapType].min!==null){
                const delta = (this.props.doseMap.displayScaleVal[thisDoseMapType].max! - this.props.doseMap.displayScaleVal[thisDoseMapType].min!)/6.0;

                let resetMinVal:number;
                if(this.props.doseMap.globalScaleVal[thisDoseMapType].min !==null){
                    resetMinVal = this.props.doseMap.globalScaleVal[thisDoseMapType].min!;
                } else {
                    resetMinVal = this.props.doseMap.dataScaleVal[thisDoseMapType].min!;
                }

                const thisLabelMin = this.makeThreshDisplay('Min Thr',thisDoseMapType,DoseMapMinMaxEnum.MIN,
                                                        this.props.doseMap.displayScaleVal[thisDoseMapType].min!, resetMinVal!, delta,
                                                        this.handleSetMinValueClick,{top:'-4px',left:'-5px'})
                colorbarValueLabelDisplay.push(thisLabelMin)

                for(let i=1;i<6;i++){
                    const thisLabel = <div className={'colorbar-ticklabel'} key={"label"+i.toFixed(0)}>{(this.props.doseMap.displayScaleVal[thisDoseMapType].min!+delta*i).toFixed(1)}</div>
                    colorbarValueLabelDisplay.push(thisLabel);
                }

                //click to change max threshold
                let resetMaxVal:number;
                if(this.props.doseMap.globalScaleVal[thisDoseMapType].max !==null){
                    resetMaxVal = this.props.doseMap.globalScaleVal[thisDoseMapType].max!;
                } else {
                    resetMaxVal = this.props.doseMap.dataScaleVal[thisDoseMapType].max!;
                }
                const thisLabelMax = this.makeThreshDisplay('Max Thr',thisDoseMapType,DoseMapMinMaxEnum.MAX,
                                                    this.props.doseMap.displayScaleVal[thisDoseMapType].max!,resetMaxVal,delta,
                                                    this.handleSetMaxValueClick,{top:'-4px',right:'-5px'})
                colorbarValueLabelDisplay.push(thisLabelMax)
            }

        }
        let colorbarDisplay;
        if(this.props.doseMapAnalysisInterface?.doseMapType && this.props.doseMap){
            colorbarDisplay =
                        <div id={"dose-rate-colorbar"} className={"colorbar"}>
                            <div className="colorbar-label">{doseMapLabel}</div>
                            <img src={colorbar_logo} style={{opacity: 0.5}} alt="Colorbar"/>
                            <div style={{ display: 'flex', position: 'relative', justifyContent: 'space-between' }}>
                                {colorbarValueLabelDisplay}
                            </div>
                        </div>
        }
        return (
            <>
            {colorbarDisplay}
            </>
        )
    }
}

/*******************************************************************************/

interface SettingsInputDisplayProps {
    label: String,
    doseMapMaxMin:DoseMapMinMaxEnum,
    initValue: number,
    resetValue: number,
    callback: (returnvalue:number|null, applyToAll:boolean|null) => void,
    style?: CSSProperties;
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,

}
interface SettingsInputDisplayState {
    dose_rate_input_value:string,
    apply_thr_to_all: boolean,
}
export class SettingsInputDisplay extends React.Component<SettingsInputDisplayProps,SettingsInputDisplayState> {
    editTimeoutTimer: NodeJS.Timeout | null;
    displayTimeoutTimer: NodeJS.Timeout | null;
    editing: boolean = false;
    input_last_changed:number = 0;
    fixed_decimal_places:number = 2;
    timeoutPeriod = 8000; //8ooo default
    //threshold_off_value: number =
    constructor(props: SettingsInputDisplayProps) {
        super(props)

        this.state={
            dose_rate_input_value: this.props.initValue.toFixed(this.fixed_decimal_places),
            apply_thr_to_all: true, //false,
        }
        this.editTimeoutTimer = null;
        this.displayTimeoutTimer = null;
        //this.setIsotopeThresholdFunction = this.setIsotopeThresholdFunction.bind(this);
        this.handleOnSetClick = this.handleOnSetClick.bind(this);
        this.handlePasswordInputKeyPress = this.handlePasswordInputKeyPress.bind(this);
        this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this);
        this.setEditing = this.setEditing.bind(this);
        this.handleSelectA = this.handleSelectA.bind(this);
        this.handleSelectB = this.handleSelectB.bind(this);
        this.handleReset = this.handleReset.bind(this);
    }
    componentDidMount(){
        this.resetDisplayTimeout();
        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapScaleOverride && this.props.doseMapAnalysisInterface.doseMapType){
                if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MAX){
                    if(this.props.doseMapAnalysisInterface.doseMapScaleOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].max === true){
                        this.setState({apply_thr_to_all: true});
                    }
                } else if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                    if(this.props.doseMapAnalysisInterface.doseMapScaleOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].min === true){
                        this.setState({apply_thr_to_all: true});
                    }
                }
            }
        }
    }
    componentWillUnmount(){
        if(this.editTimeoutTimer !== null) {
            clearTimeout(this.editTimeoutTimer);
            this.editTimeoutTimer = null;
        }
        if(this.displayTimeoutTimer !== null) {
            clearTimeout(this.displayTimeoutTimer);
            this.displayTimeoutTimer = null;
        }
    }
    handleCloseButtonClick(){
        this.setEditTimeout();
    }

    setEditTimeout(){
        console.log('SettingsInputDisplay timeout')
        this.props.callback(this.props.initValue,this.state.apply_thr_to_all);
        if(this.props.doseMapAnalysisInterface?.doseMapSelected === 'C'){
            this.props.callback(this.props.initValue,null);
        } else {
            this.props.callback(this.props.initValue,this.state.apply_thr_to_all);
        }
        //this.resetEditTimeout();
    }

    handleOnSetClick(){
        if(this.editTimeoutTimer !== null) {
            clearTimeout(this.editTimeoutTimer);
            this.editTimeoutTimer = null;
        }
        this.editTimeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, this.timeoutPeriod);
        this.checkDoseAlarmThreshold();
        //this.setIsotopeThreshold();
        if(this.props.doseMapAnalysisInterface?.doseMapSelected === 'C'){
            this.props.callback(parseFloat(this.state.dose_rate_input_value),null);
        } else {
            this.props.callback(parseFloat(this.state.dose_rate_input_value),this.state.apply_thr_to_all);
        }

    }

    checkDoseAlarmThreshold(){
        let inputval = parseFloat(this.state.dose_rate_input_value);
        if(isNaN(inputval)){// || inputval === this.threshold_off_value*this.dose_rate_conversion){
            //inputval = this.getDefaultDoseRateAlarmThresh()*this.dose_rate_conversion;
            inputval = this.props.initValue;
        }
        this.setState({
            dose_rate_input_value: inputval.toFixed(this.fixed_decimal_places)
        })
    }

    handlePasswordInputKeyPress(event:React.KeyboardEvent){
        let code = event.keyCode || event.which;
        if(code === 13) { //13 is the enter keycode
            //console.log('return pressed')
            this.checkDoseAlarmThreshold();
            this.handleOnSetClick();

            event.preventDefault();
        }
    }
    updateInput(event:React.ChangeEvent<HTMLInputElement>){
        let value = event.currentTarget.value;
        if (/\D/g.test(value)){
            value = value.replace(/[^-?\d*\.{0,1}\d+$]/g,'');
        }
        this.input_last_changed = new Date().getTime();
        this.resetEditTimeout();
        this.resetDisplayTimeout();

        this.setState({ dose_rate_input_value: value })

    }
    resetEditTimeout(){
        if(this.editTimeoutTimer !== null) {
            clearTimeout(this.editTimeoutTimer);
            this.editTimeoutTimer = null;
        }
        this.editTimeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, this.timeoutPeriod);
    }
    resetDisplayTimeout(){
        if(this.displayTimeoutTimer !== null){
            clearTimeout(this.displayTimeoutTimer)
        }
        this.displayTimeoutTimer = setTimeout(() => {
            this.setEditTimeout();
        }, this.timeoutPeriod);
    }
    setEditing(flag:boolean){
        if(flag){
            this.editing = true;
        } else {
            this.editing = false;
            if(this.editTimeoutTimer !== null) {
                clearTimeout(this.editTimeoutTimer);
                this.editTimeoutTimer = null;
            }
        }
    }

    handleSelectA(){
        this.resetDisplayTimeout();
        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapSelected === 'B'){
                this.setState({apply_thr_to_all:!this.state.apply_thr_to_all});
            }
        }
    }
    handleSelectB(){
        this.resetDisplayTimeout();
        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapSelected === 'A'){
                this.setState({apply_thr_to_all:!this.state.apply_thr_to_all});
            }
        }
    }
    handleReset(){
        this.resetDisplayTimeout();
        console.log('handleReset')

        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapSelected &&
                this.props.doseMapAnalysisInterface.setScale &&
                this.props.doseMapAnalysisInterface.doseMapType){

                if(this.props.doseMapAnalysisInterface.doseMapSelected === 'C'){
                    this.props.callback(null,null);
                } else {
                    this.props.callback(null,true);
                }
            }
        }

    }
    render(){
        let value = this.state.dose_rate_input_value;
        let doseRateAlarmThreshClass = '';
        let disabledClass;
        disabledClass='disabled';

        const thisDoseMapType = this.props.doseMapAnalysisInterface?.doseMapType;
        let ganged_flag = false;
        if(this.props.doseMapAnalysisInterface?.doseMapScaleOverride && thisDoseMapType){
            if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MAX){
                ganged_flag = this.props.doseMapAnalysisInterface?.doseMapScaleOverride[thisDoseMapType]['GANG'].max;
            } else {
                ganged_flag = this.props.doseMapAnalysisInterface?.doseMapScaleOverride[thisDoseMapType]['GANG'].min;
            }
        }

        if(parseFloat(this.state.dose_rate_input_value) !== this.props.initValue){
            this.setEditing(true);
            doseRateAlarmThreshClass = ' changed';
            disabledClass = 'changed';
        } else if (this.state.apply_thr_to_all){
            disabledClass = '';
        } else {
            this.setEditing(false);
        }


        let input_field =  <input type="thresh"  className={doseRateAlarmThreshClass} name="thresh" autoComplete='off'
                value={value} onChange={(e)=>this.updateInput(e)} onKeyPress={this.handlePasswordInputKeyPress} required placeholder=" "/>

        let dose_rate_unit_string = '\u00B5R/hr';
        //if (this.props.useDoseRateSIUnit === true){
        //    dose_rate_unit_string = '\u00B5Sv/hr'
        //}
        let selectAClass;
        let selectBClass;
        let selectCClass;
        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapSelected){
                if(this.props.doseMapAnalysisInterface.doseMapSelected !== 'C'){
                    // A OR B SELECTED
                    if(this.props.doseMapAnalysisInterface.doseMapSelected === 'A'){
                        selectAClass = 'active';
                    } else if(this.props.doseMapAnalysisInterface.doseMapSelected === 'B'){
                        selectBClass = 'active';
                    }

                    if(this.state.apply_thr_to_all){
                        selectAClass = 'active';
                        selectBClass = 'active';
                    }
                    if(this.props.doseMapAnalysisInterface.doseMapScaleOverride && this.props.doseMapAnalysisInterface.doseMapType){
                        if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MAX){
                            if(this.props.doseMapAnalysisInterface.doseMapScaleOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].max === true){
                                selectAClass = 'active';
                                selectBClass = 'active';
                            }
                        } else if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                            if(this.props.doseMapAnalysisInterface.doseMapScaleOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].min === true){
                                selectAClass = 'active';
                                selectBClass = 'active';
                            }
                        }
                    }
                    if(!this.props.doseMapAnalysisInterface.doseMapsAvailable?.includes('A')){
                        selectAClass = 'inactive';
                    }
                    if(!this.props.doseMapAnalysisInterface.doseMapsAvailable?.includes('B')){
                        selectBClass = 'inactive';
                    }
                } else {
                    // C SELECTED
                    selectCClass = 'active';
                }
            }
        }
        let resetClass='inactive';
        //if(this.props.initValue !== this.props.resetValue ){
        if(this.props.doseMapAnalysisInterface){
            const thisOverride = this.props.doseMapAnalysisInterface?.doseMapScaleOverride;
            const thisDoseMapSelected = this.props.doseMapAnalysisInterface?.doseMapSelected;
            if(thisOverride && thisDoseMapSelected){
                if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MAX){
                    if(this.props.doseMapAnalysisInterface.doseMapType)
                        if(thisOverride[this.props.doseMapAnalysisInterface.doseMapType][thisDoseMapSelected].max ||
                           thisOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].max){
                            resetClass = 'active';
                        }

                } else if(this.props.doseMapMaxMin === DoseMapMinMaxEnum.MIN){
                    if(this.props.doseMapAnalysisInterface.doseMapType)
                        if(thisOverride[this.props.doseMapAnalysisInterface.doseMapType][thisDoseMapSelected].min ||
                           thisOverride[this.props.doseMapAnalysisInterface.doseMapType]['GANG'].min){
                            resetClass = 'active';
                        }
                }
            }
        }


        let option_button;
        if(selectAClass || selectBClass){

            option_button =
                <div className="option-icon-bar" style={{ paddingLeft: '0px', paddingBottom: '2px' }}>
                    <div className={"axis-type " + selectAClass}> FOREGND </div>
                    <div className={"axis-type " + selectBClass}> BASELNE </div>
                    {/*<div className={"axis-type " + selectAClass} onClick={this.handleSelectA}> FOREGND </div>*/}
                    {/*<div className={"axis-type " + selectBClass} onClick={this.handleSelectB}> BASELNE </div>*/}
                </div>
        } else if(selectCClass){
            option_button =
                <div className="option-icon-bar" style={{ paddingLeft: '0px', paddingBottom: '2px' }}>
                    <div className={"axis-type " + selectCClass}> RESULT </div>
                    {/*<div className={"axis-type " + selectCClass} onClick={this.handleSelectA}> RESULT </div>*/}
                </div>
        }
        return(
            <div className="DialogWindow" style={this.props.style}>
                <div className="closebtn" style={{ cursor: 'pointer', fontSize:'24px', position:'absolute', top:'-6px',right:'4px' }} onClick={this.handleCloseButtonClick}>&times;</div>

                <div style={{display:'flex', flexDirection:'column'}}>
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between',paddingRight:'7px'}}>
                        {option_button}
                        <div className="option-icon-bar" style={{ paddingLeft: '10px', paddingBottom: '2px' }}>
                            <div className={"axis-type " + resetClass} onClick={this.handleReset}> RESET </div>
                        </div>
                    </div>

                    <div style={{display:'flex', flex:1, flexDirection:'row', justifyContent:'space-between', padding:'3px',paddingRight:'3px',paddingLeft:'3px',alignItems:'center'}}>
                        <div style={{display:'flex', flexDirection:'row', alignItems:'baseline'}}>
                            <label className="status-metric-title" style={{width:'fit-content',whiteSpace:'normal'}}>{this.props.label}</label>
                            <div style={{display:'flex', flexDirection:'row', padding:'0px', margin:'0px', width:'100px',alignItems:'center'}}>
                                <form className={"isotope-thresh"} action="#0">
                                    <div>
                                        {input_field}
                                    </div>
                                    </form>
                                <label  className="units" style={{textAlign:'center',padding:'3px'}}>{dose_rate_unit_string}</label>
                            </div>
                        </div>

                        <div style={{display:'flex', flexDirection:'row', alignSelf:'center'}}>
                            <div  className={"round-skinny-button "+disabledClass} onClick={this.handleOnSetClick}>Set</div>
                        </div>
                    </div>

                </div>
            </div>

        )
    }
}

/*******************************************************************************/

export interface DoseMapSelectDisplayProps {
    doseMapKey: string,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
}

export interface DoseMapSelectDisplayState {
}

export class DoseMapSelectDisplay extends React.Component<DoseMapSelectDisplayProps,DoseMapSelectDisplayState> {

    //dummyDatesAvailable:number[] = [1732665600000,1732579200000,1732492800000];


    constructor(props: DoseMapSelectDisplayProps) {
        super(props)

        this.state={
        }

    }
    /*
    componentDidUpdate(prevProps: DoseMapSelectDisplayProps, prevState: DoseMapSelectDisplayState) {
        if(this.props.doseMapAnalysisInterface?.doseMapDateSelected === undefined
            && this.props.doseMapAnalysisInterface?.doseMapDateSelected !== prevProps.doseMapAnalysisInterface?.doseMapDateSelected){
                if(this.props.doseMapAnalysisInterface?.doseMapSelected === this.props.doseMapKey){
                    console.log('unselecting dose map type since map is undefined')
                    this.props.doseMapAnalysisInterface?.selectDoseMapType(undefined);
                }
            }
    }
    */
    convertHistDateToDateString(hist_date:string){
        const thisYear = Number(hist_date.substring(0,4));
        const thisMonth = Number(hist_date.substring(4,6));
        const thisDay = Number(hist_date.substring(6,8));
        const thisDateString = thisMonth.toFixed()+'/'+thisDay.toFixed()+'/'+thisYear.toFixed();
        return thisDateString;
    }
    convertDateStringToHistDate(dateString:string){
        const str = dateString.split('/');
        const thisYearStr = Number(str[2]).toFixed(0).padStart(4,'0');;
        const thisMonthStr = Number(str[0]).toFixed(0).padStart(2,'0');
        const thisDayStr = Number(str[1]).toFixed(0).padStart(2,'0');
        const hist_date = thisYearStr+thisMonthStr+thisDayStr;
        return hist_date;
    }

    render(){

        let doseMapDateAvailable = this.props.doseMapAnalysisInterface?.doseMapDateAvailable;
        let doseMapDateSelected = this.props.doseMapAnalysisInterface?.doseMapDateSelected[this.props.doseMapKey];

        let mapDatesAvailableString:string[] = [];
        if(doseMapDateAvailable){
            doseMapDateAvailable.forEach(hist_date => {
                const thisDateString = this.convertHistDateToDateString(hist_date)
                /*
                const datenumber =  Number(datestring);
                const thisDateString = new Date(datenumber).toDateString();
                */
                mapDatesAvailableString.push(thisDateString);
            });
        }
        if(doseMapDateSelected && doseMapDateSelected.includes(DoseMapLoadedFromFileString)){
            mapDatesAvailableString.push(doseMapDateSelected)
        }
        mapDatesAvailableString.push(DoseMapLoadFromFileString);
        //LIVE option only for slot A (FOREGROUND)
        if(this.props.doseMapKey==='A'){
            mapDatesAvailableString.unshift(DoseMapLiveString);
        }
        //Get devicesAvailable from data
        //let devicesAvailableString = Object.keys(this.props.devices).sort();


        //Add non-select if missing
        if(!mapDatesAvailableString.find(el => {if(el.includes('--')) return true}))
            mapDatesAvailableString.unshift('--');

        //TODO add offline option

        const mapDatesAvailable = mapDatesAvailableString.map((mode,idx) =>
            <option value={mode} key={mode+'_'+idx+'_devices'}>{mode}</option>)

        if(doseMapDateSelected){
            if(doseMapDateSelected === ""){
                doseMapDateSelected = mapDatesAvailableString[0];
            } else if(doseMapDateSelected.includes(DoseMapLoadFromFileString)){
                doseMapDateSelected = DoseMapLoadFromFileString
            } else if(doseMapDateSelected.includes(DoseMapLoadedFromFileString)){

            } else if(doseMapDateSelected === DoseMapLiveString){
                doseMapDateSelected = DoseMapLiveString;
            } else {
                //const datenumber =  Number(doseMapDateSelected);
                //doseMapDateSelected = new Date(datenumber).toDateString();
                doseMapDateSelected = this.convertHistDateToDateString(doseMapDateSelected);
            }
        }

        const selectMapHeader =
            <select className="modern-skinny" style={{lineHeight:'1.87em',width:'170px'}} value={doseMapDateSelected}
                onChange={(e) => {
                    //this.deviceNameToDisplay = e.target.value;
                    console.log('changing map date to '+e.target.value)

                    let dateSelected = e.currentTarget.value;
                    if(dateSelected === '--'){
                        dateSelected = '';
                    } else if(dateSelected.includes(DoseMapLoadFromFileString)) {
                        dateSelected = DoseMapLoadFromFileString;
                        let button = document.getElementById('load-from-file-button-'+this.props.doseMapKey);
                        if(button !== null){
                            button.click();
                            console.log('click loadfile')
                        }
                    } else if(dateSelected.includes(DoseMapLoadedFromFileString)){

                    } else if(dateSelected === DoseMapLiveString) {
                        dateSelected = DoseMapLiveString;
                        if(this.props.doseMapAnalysisInterface?.selectLiveData){
                            this.props.doseMapAnalysisInterface?.selectLiveData(true);
                        }
                    } else {
                        //Parse date
                        dateSelected = this.convertDateStringToHistDate(dateSelected);
                        console.log('reconstituted hist_date: '+dateSelected)
                        //dateSelected = Date.parse(e.target.value).toFixed();
                    }

                    this.props.doseMapAnalysisInterface?.selectDoseMapDate(this.props.doseMapKey,dateSelected);

                }}>
                {mapDatesAvailable}
            </select>


        return(
            <div key={'key'} style={{background:'#282828',marginTop:'0px', paddingTop:'0px'}}>
                <div style={{display:'flex',flexDirection:'row'}}>
                    {selectMapHeader}
                </div>
            </div>
        )
    }
}

/*******************************************************************************/

export interface AnalysisMethodSelectDisplayProps {
    //doseMap?: DoseMapMessage,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
}

export interface AnalysisMethodSelectDisplayState {
}

export class AnalysisMethodSelectDisplay extends React.Component<AnalysisMethodSelectDisplayProps,AnalysisMethodSelectDisplayProps> {

    analysisMethodsAvailable:string[] = ['Difference (F-B)','Z-Score (F-B)','Combine'];

    constructor(props: DoseMapSelectDisplayProps) {
        super(props)

        this.state={
        }

    }
    componentDidUpdate(prevProps: AnalysisMethodSelectDisplayProps, prevState: AnalysisMethodSelectDisplayState) {

    }


    render(){

        let analysisAvailableString:string[] = [];
        this.analysisMethodsAvailable.forEach(method => {
            const thisMethodString = method;
            analysisAvailableString.push(thisMethodString);
        });

        //Add non-select if missing
        if(!analysisAvailableString.find(el => {if(el.includes('--')) return true}))
            analysisAvailableString.unshift('--');

        //TODO add offline option

        const analysisAvailable = analysisAvailableString.map((mode,idx) =>
            <option value={mode} key={mode+'_'+idx+'_devices'}>{mode}</option>)

        let methodName = analysisAvailableString[0];
        if(this.props.doseMapAnalysisInterface){
            if(this.props.doseMapAnalysisInterface.doseMapAnalysisType){
                if(this.props.doseMapAnalysisInterface.doseMapAnalysisType === DoseAnalysisType.DIFFERENCE){
                    methodName = analysisAvailableString[DoseAnalysisType.DIFFERENCE];
                } else if(this.props.doseMapAnalysisInterface.doseMapAnalysisType === DoseAnalysisType.ZSCORE){
                    methodName = analysisAvailableString[DoseAnalysisType.ZSCORE];
                } else if(this.props.doseMapAnalysisInterface.doseMapAnalysisType === DoseAnalysisType.COMBINE){
                    methodName = analysisAvailableString[DoseAnalysisType.COMBINE];
                }
            }
        }
        const selectMethodHeader =
            <select className="modern-skinny" style={{lineHeight:'1.87em',width:'170px'}} value={methodName}
                onChange={(e) => {
                    //this.deviceNameToDisplay = e.target.value;
                    console.log('changing analysis method to '+e.target.value)
                    let analysisType:DoseAnalysisType|undefined = undefined
                    let methodNameSelected = e.currentTarget.value;
                    if(methodNameSelected === '--'){
                        analysisType = undefined;
                    } else if(methodNameSelected === analysisAvailableString[DoseAnalysisType.DIFFERENCE]){
                        analysisType = DoseAnalysisType.DIFFERENCE;
                    } else if(methodNameSelected === analysisAvailableString[DoseAnalysisType.ZSCORE]){
                        analysisType = DoseAnalysisType.ZSCORE;
                    } else if(methodNameSelected === analysisAvailableString[DoseAnalysisType.COMBINE]){
                        analysisType = DoseAnalysisType.COMBINE;
                    }

                    this.props.doseMapAnalysisInterface?.selectDoseMapAnalysisType(analysisType);


                }}>
                {analysisAvailable}
            </select>


        return(
            <div key={'key'} style={{background:'#282828',marginTop:'0px', paddingTop:'0px'}}>
                <div style={{display:'flex',flexDirection:'row'}}>
                    {selectMethodHeader}
                </div>
            </div>
        )
    }
}

/*******************************************************************************/

export interface DoseMapStatDisplayProps {
    doseMap?: DoseMapMessage,
    doseMapKey: string,
    doseMapAnalysisInterface?: DoseMapAnalysisInterface,
}

export interface DoseMapStatDisplayState {
}

export class DoseMapStatDisplay extends React.Component<DoseMapStatDisplayProps,DoseMapStatDisplayState> {

    constructor(props: DoseMapStatDisplayProps) {
        super(props)

        this.state={
        }

    }

    render(){
        let dosemap_min = "--";
        let dosemap_max = "--";
        const thisDoseMapType = this.props.doseMapAnalysisInterface?.doseMapType;
        if(thisDoseMapType){
            if(this.props.doseMap?.dataScaleVal[thisDoseMapType] !== null
                && this.props.doseMap?.dataScaleVal[thisDoseMapType].min !== undefined && this.props.doseMap?.dataScaleVal[thisDoseMapType].min !== null){
                dosemap_min = this.props.doseMap?.dataScaleVal[thisDoseMapType].min!.toFixed(2);
            }
            if(this.props.doseMap?.dataScaleVal[thisDoseMapType].max !== null
                && this.props.doseMap?.dataScaleVal[thisDoseMapType].max !== undefined && this.props.doseMap?.dataScaleVal[thisDoseMapType].max !== null){
                dosemap_max = this.props.doseMap?.dataScaleVal[thisDoseMapType].max!.toFixed(2);
            }
        }

        let dosemap_date = "--";
        if(this.props.doseMap?.lastUpdatedTime !== null && this.props.doseMap?.lastUpdatedTime){
            dosemap_date = new Date(this.props.doseMap?.lastUpdatedTime*1000).toLocaleString().replace(',','')
        }

        return(
            <div key={this.props.doseMapKey} style={{background:'#202020',marginTop:'0px', alignSelf:'end',paddingTop:'0px',paddingLeft:'5px'}}>
                <div style={{display:'flex',flexDirection:'row',width:'250px'}}>
                    <div className="tiny-metric-container" style={{}}>
                        <label className="tiny-metric-title">Min:</label>
                        <label className="tiny-metric-title">{dosemap_min}</label>
                    </div>
                    <div className="tiny-metric-container" style={{}}>
                        <label className="tiny-metric-title">Max:</label>
                        <label className="tiny-metric-title">{dosemap_max}</label>
                    </div>
                </div>
                <div style={{display:'flex',flexDirection:'row',width:'250px'}}>
                    <div className="tiny-metric-container" style={{}}>
                        <label className="tiny-metric-title">Last Updated:</label>
                        <label className="tiny-metric-title">{dosemap_date}</label>
                    </div>
                    </div>
            </div>
        )

    }
}
